<div class="kt-header__topbar">

    <div class="kt-header__topbar-item pe-2" (click)="showSidebar($event)">
        <div class="d-flex align-items-center justify-content-center h-100">
            <!-- Start Shift -->
            <ng-container *ngxPermissionsOnly="permissionV2.MANAGE_OWN_SHIFT_MANAGE">
                <button type="button"
                    class="btn btn-sm button-brand me-1 d-flex justify-content-around flex-row brand-config-color-hover"
                    *ngIf="currentStatus === timesheetenumRef.NONE">
                    <svg-icon class="white-config-color me-1 svg_icon17x17" src="assets/media/iq-svg/without_circle/icon_set_3/play.svg"></svg-icon>
                    Start Shift
                </button>
            </ng-container>

            <!-- On Break -->
            <button type="button" class="btn btn-sm button-warning warning-config-color-hover"
                *ngIf="currentStatus === timesheetenumRef.ONBREAK">
                <svg-icon class="black-config-color d-inline me-1 svg_icon17x17" src="assets/media/iq-svg/without_circle/icon_set_3/pause.svg"></svg-icon>
                On Break ({{timeElapsed()}})
            </button>
            <!-- Current Status -->
            <button type="button" class="btn btn-sm button-success success-config-color-hover"
                *ngIf="currentStatus !== timesheetenumRef.NONE && currentStatus !== timesheetenumRef.ONBREAK">
                <svg-icon class="white-config-color d-inline svg_icon17x17" src="assets/media/iq-svg/without_circle/icon_set_3/resume.svg"></svg-icon>
                {{timeElapsed()}}
            </button>
        </div>
    </div>

    <div class="separator-v"></div>

    <div class="kt-header__topbar-item help" ngbDropdown placement="bottom-right">
        <div class="kt-header__topbar-wrapper" ngbDropdownToggle>
            <span class="kt-header__topbar-icon kt-pulse kt-pulse--brand position-relative nohover">
                <svg-icon class="svg_icon17x17 brand-config-color-hover" src="assets/media/iq-svg/without_circle/icon_set_4/Help.svg"></svg-icon>
            </span>
        </div>
        <div class="dropdown-menu-fit dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl" ngbDropdownMenu>
            <div class="kt-grid-nav border-bottom">
                <div class="kt-grid-nav__row">

                    <a href="https://links.iqcheckpoint.com/yt-web"
                        class="kt-grid-nav__item dropdown-item support-width-50" target="_blank">
                        <span class="kt-grid-nav__icon">
                            <!-- <img src="assets/media/icons/with-opacity/tutorial.svg" alt="" height="60"> -->
                            <svg-icon class="d-inline" src="assets/media/iq-svg/with_circle/icon_set_4/tutorial.svg"></svg-icon>
                        </span>
                        <span class="kt-grid-nav__title">Tutorial</span>
                    </a>

                    <a href="https://updates.iqcheckpoint.com/iqcheckpoint/kb"
                        class="kt-grid-nav__item dropdown-item support-width-50" target="_blank">
                        <span class="kt-grid-nav__icon">
                            <!-- <img src="assets/media/icons/with-opacity/help_guide.svg" alt="" height="60"> -->
                            <svg-icon class="d-inline" src="assets/media/iq-svg/with_circle/icon_set_4/help_guide.svg"></svg-icon>
                        </span>
                        <span class="kt-grid-nav__title">Help Guide</span>
                    </a>

                </div>
                <div class="kt-grid-nav__row">

                    <a href="https://updates.iqcheckpoint.com/iqcheckpoint#/ideas"
                        class="kt-grid-nav__item dropdown-item support-width-50" target="_blank">
                        <span class="kt-grid-nav__icon">
                            <!-- <img src="assets/media/icons/with-opacity/share_idea.svg" alt="" height="60"> -->
                            <svg-icon class="d-inline" src="assets/media/iq-svg/with_circle/icon_set_4/share_idea.svg"></svg-icon>
                        </span>
                        <span class="kt-grid-nav__title">Share Your Ideas</span>
                    </a>

                    <a href="javascript:void(0);" class="kt-grid-nav__item dropdown-item support-width-50"
                        (click)="displayFreshchatWidget ? closeChat(true) : openChat()">
                        <span class="kt-grid-nav__icon">
                            <!-- <img src="assets/media/icons/with-opacity/chat_support_show.svg" alt="" height="60"> -->
                            <svg-icon class="d-inline" src="assets/media/iq-svg/with_circle/icon_set_4/chat_support_show.svg"></svg-icon>
                        </span>
                        <!-- Change label: Hide-Show -->
                        <span class="kt-grid-nav__title">Chat Support <small>({{ displayFreshchatWidget ? 'Hide': 'Show'
                                }})</small></span>
                    </a>
                </div>

            </div>

            <div class="text-center px-3 py-5">
                <div class="h6">Let's talk!</div>

                <a class="kt-font-brand fw-bold" href="tel:1300 816 200"> Call On: 1300 816 200</a><br>
                <a href="mailto:support@iqcheckpoint.com"
                    class="kt-font-brand fw-bold">Email At: support&#64;iqcheckpoint.com</a>
            </div>

        </div>
    </div>

    <div class="kt-header__topbar-item" (click)="showNotificatinBar($event)">
        <div class="kt-header__topbar-wrapper">
            <span class="kt-header__topbar-icon kt-pulse kt-pulse--brand position-relative nohover">
                <svg-icon class="svg_icon17x17 brand-config-color-hover" src="assets/media/iq-svg/without_circle/icon_set_3/notification_bell.svg"></svg-icon>
                <span class="kt-badge kt-badge--warning kt-badge--dot kt-badge--xl notification-badge"
                    *ngIf="unreadNotifications()"></span>
            </span>
        </div>

    </div>

    <div class="kt-header__topbar-item">
        <div class="kt-header__topbar-wrapper roadmap" id="roadmap" (click)="showProductMap()">
            <span class="kt-header__topbar-icon kt-pulse kt-pulse--brand position-relative nohover ">
                <svg-icon class="svg_icon17x17 brand-config-color-hover" src="assets/media/iq-svg/without_circle/icon_set_3/recent_updates.svg"></svg-icon>
            </span>
        </div>
    </div>

    <div class="separator-v"></div>

    <div ngbDropdown placement="bottom-right" class="kt-header__topbar-item kt-header__topbar-item--user"
        *ngIf="user$ | async as _user">
        <div ngbDropdownToggle class="kt-header__topbar-wrapper">
            <a class="">
                <img *ngIf="_user?.user_business_profile_image_url" alt="Pic" height="35" width="35"
                    class="rounded-circle" [src]="_user?.user_business_profile_image_url">
            </a>

            <span *ngIf="!_user?.user_business_profile_image_url" style="margin-right: 5px;background-color: lightgrey;"
                class="kt-header__topbar-icon">
                <div class="rounded-circle media-size">
                    {{(_user?.user_business_first_name?.toUpperCase() + ' ' +
                    _user?.user_business_last_name?.toUpperCase() )|
                    firstLetter}}</div>
            </span>
        </div>

        <div ngbDropdownMenu
            class="dropdown-menu dropdown-menu-fit dropdown-menu-end dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
            <!--begin: Head -->
            <div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x rounded-head"
                style="background-image: url(./assets/media/misc/bg-1.jpg)">
                <a class="">

                    <img *ngIf="_user?.user_business_profile_image_url" alt="Pic" height="35" width="35"
                        class="rounded-circle" [src]="_user?.user_business_profile_image_url">
                </a>
                <span class="kt-header__topbar-wrapper">
                    <span *ngIf="!_user?.user_business_profile_image_url"
                        style="margin-right: 5px;background-color: lightgrey;" class="kt-header__topbar-icon">
                        <div class="rounded-circle media-size">
                            {{(_user?.user_business_first_name?.toUpperCase() + ' ' +
                            _user?.user_business_last_name?.toUpperCase()) |
                            firstLetter}}
                        </div>
                    </span>
                </span>
                <div class="kt-user-card__name">
                    {{(_user?.user_business_first_name + ' ' + _user?.user_business_last_name)}}
                </div>
            </div>
            <!--end: Head -->

            <!--begin: Navigation -->
            <div class="kt-notification">
                <a (click)="myProfileClickHandler()" ngbDropdownItem href="javascript:void(0);"
                    class="kt-notification__item brand-config-color-hover">
                    <div class="kt-notification__item-icon">
                        <svg-icon class="my_profile_svg-icon" src="assets/media/iq-svg/without_circle/icon_set_4/my_profile_icon.svg"></svg-icon>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            My Profile
                        </div>
                    </div>
                </a>
                <a  *ngxPermissionsOnly="permissionV2.SELF_PEOPLE_FINANCIAL_DETAILS_ACCESS" (click)="kioskClickHandler()" ngbDropdownItem href="javascript:void(0);"
                    class="kt-notification__item brand-config-color-hover">
                    <div class="kt-notification__item-icon">
                        <svg-icon class="my_profile_svg-icon" src="assets/media/iq-svg/without_circle/icon_set_3/kiosk.svg"></svg-icon>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            Kiosk PIN
                        </div>
                    </div>
                </a>
                <a (click)="changePasswordHandler()" ngbDropdownItem href="javascript:;"
                    class="kt-notification__item brand-config-color-hover">
                    <div class="kt-notification__item-icon">
                        <svg-icon class="my_profile_svg-icon" src="assets/media/iq-svg/without_circle/icon_set_4/Change_Password.svg"></svg-icon>
                    </div>
                    <div class="kt-notification__item-details">
                    <div class="kt-notification__item-title kt-font-bold">
                            Change Password
                        </div>
                    </div>
                </a>
                <a *ngIf="isAdmin" (click)="billingClickHandler()" ngbDropdownItem href="javascript:;"
                    class="kt-notification__item brand-config-color-hover">
                    <div class="kt-notification__item-icon">
                        <svg-icon class="my_profile_svg-icon" src="assets/media/iq-svg/without_circle/icon_set_4/Billing.svg"></svg-icon>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            Billing
                        </div>
                    </div>
                </a>
                <a (click)="switchBusinessClickHandler()" ngbDropdownItem href="javascript:;"
                    class="kt-notification__item brand-config-color-hover">
                    <div class="kt-notification__item-icon">
                        <svg-icon class="my_profile_svg-icon" src="assets/media/iq-svg/without_circle/icon_set_4/Switch_Business.svg"></svg-icon>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-title kt-font-bold">
                            Switch Business
                        </div>
                    </div>
                </a>


                <div class="kt-notification__custom">
                    <a href="javascript:;" (click)="logout()"
                        class="btn btn-outline-brand btn-upper btn-sm btn-bold">Sign
                        Out</a>
                </div>
                <!--end: Navigation -->

            </div>
        </div>
    </div>
</div>
